import { css } from '@emotion/react';

export const readingTime = css`
  display: flex;
  align-items: center;
  gap: 5px;
`;
